"use client";

import { MapPin } from "lucide-react";
import Link from "next/link";
import { useState, useEffect } from "react";
import Image from "next/image";

const themeItems = [
	{ label: "Sustainability and Green Initiatives", icon: "/temp/promotions/sgi-icon.png" },
	{ label: "Policies and Regulation in Real Estate", icon: "/temp/promotions/prrl-icon.png" },
	{ label: "Investment Strategies and Opportunities", icon: "/temp/promotions/isso-icon.png" },
	{
		label: "Proptech Innovation and Digital Transformation",
		icon: "/temp/promotions/pidt-icon.png",
	},
	{ label: "Startup ScaleUp Pitch Competition", icon: "/temp/promotions/scpc-icon.png" },
	{ label: "Artificial Intelligence (AI) in Real Estate", icon: "/temp/promotions/ai-icon.png" },
	{ label: "Future of Work", icon: "/temp/promotions/fw-icon.png" },
	{ label: "Smart Cities and Urban Innovation", icon: "/temp/promotions/scui-icon.png" },
	{ label: "Future of Property Management", icon: "/temp/promotions/fpm-icon.png" },
];

export const LondonProptechCard: React.FC = () => {
	const [timeLeft, setTimeLeft] = useState({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0,
	});

	useEffect(() => {
		const calculateTimeLeft = () => {
			const eventDate = new Date("April 08, 2025 00:00:00").getTime();
			const now = new Date().getTime();
			const difference = eventDate - now;

			const days = Math.floor(difference / (1000 * 60 * 60 * 24));
			const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((difference % (1000 * 60)) / 1000);

			setTimeLeft({ days, hours, minutes, seconds });
		};

		const timer = setInterval(calculateTimeLeft, 1000);
		calculateTimeLeft();
		return () => clearInterval(timer);
	}, []);

	return (
		<div className="flex max-w-[349px] flex-col overflow-hidden rounded-2xl bg-blue-500">
			<div className="relative flex aspect-[0.877] w-full flex-col px-5 py-5">
				<Image
					loading="lazy"
					src="/images/london-proptech-background.svg"
					alt="Big5 Background"
					className="absolute inset-0 h-full w-full object-cover"
					layout="fill"
				/>
				<div className="relative flex items-start justify-between">
					<div className="flex flex-col text-xs font-extrabold leading-tight text-white">
						<div className="self-start">April 8-9, 2025</div>
						<div className="mt-1 flex items-center gap-2">
							<MapPin className="h-[9.62px] w-[10.16px] text-white" />
							<span>ExCeL London</span>
						</div>
					</div>
					<div className="flex items-center gap-2">
						{["DAYS", "HOURS", "MINUTES", "SECONDS"].map((unit) => (
							<div
								key={unit}
								className="flex h-[31px] w-[31px] flex-col items-center justify-center rounded bg-white p-1.5"
							>
								<div className="text-base font-black leading-none text-black">
									{timeLeft[unit.toLowerCase() as keyof typeof timeLeft]}
								</div>
								<div className="text-[6px] font-medium leading-[3px] text-[#000000]">{unit}</div>
							</div>
						))}
					</div>
				</div>
				<div className="relative mt-3 h-px w-full bg-white" />
				<div className="relative mt-4 flex items-center gap-5 text-white">
					<Image
						loading="lazy"
						src="/images/london-proptech-logo.png"
						alt="Big5 Event"
						className="aspect-square w-[55px] rounded object-contain"
						width={55}
						height={55}
					/>
					<div className="flex flex-col">
						<div className="text-xs font-bold leading-4">The 3rd Annual London PropTech Show</div>
						<div className="mt-2 text-xs font-semibold leading-tight">
							Where Real Estate Meets Innovation
						</div>
					</div>
				</div>
				<div className="relative mt-5 h-px w-full bg-white" />
				{/* Conference Themes Section */}
				<div className="relative mt-5">
					<h3 className="mb-3 text-center text-xs font-bold text-white">Conference Themes</h3>
					<div className="grid grid-cols-2 gap-2 px-3 text-[10px] text-white">
						{themeItems.map(({ label, icon }, index) => (
							<div key={index} className="flex items-center gap-2">
								<Image
									src={icon}
									alt={label}
									width={40}
									height={40}
									className="h-4 w-4 object-contain"
								/>
								<span>{label}</span>
							</div>
						))}
					</div>
				</div>
				<Link
					href="https://proptechshow.com/register/?t=delegate?utm_campaign=Proptech%20Buzz&utm_medium=media-partnerships&utm_source=others"
					passHref
					legacyBehavior
				>
					<a
						className="relative mt-9 flex min-h-[48px] items-center justify-center gap-2.5 rounded-lg bg-blue-600 px-3 py-3 text-lg font-semibold text-white"
						target="_blank"
						rel="noopener noreferrer"
					>
						<div>Book Tickets</div>
					</a>
				</Link>
			</div>
		</div>
	);
};

export default LondonProptechCard;
